import Plugin from 'lib/modulor/plugin'

export default class WebModule extends Plugin
  @defaults =
    debug: false

  @selector: '.modulor_web_module'

# do not register since this is just superclass
